import React from 'react';
import styles from './FinanceCalculatorHero.module.scss';

const Hero = ({ title, description }) => {
  return (
    <div className={styles.hero}>
      <h1 className={styles.title} data-aos="fade-up">
        {title}
      </h1>
      <div
        className={styles.description}
        data-aos="fade-up"
        data-aos-delay="300"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

export default Hero;
